export class SimLookupRequestEntity {
  iccid?: string;

  constructor(data?: Partial<SimLookupRequestEntity>) {
    this.iccid = data?.iccid;
  }
}
